'use strict';

import Vue from 'vue';

import prettyBytes from './prettyBytes';

Vue.filter('prettyBytes', prettyBytes);
